import { render } from "./BasicMachineLanding.vue?vue&type=template&id=51ad7650&scoped=true"
import script from "./BasicMachineLanding.vue?vue&type=script&lang=js"
export * from "./BasicMachineLanding.vue?vue&type=script&lang=js"

import "./BasicMachineLanding.vue?vue&type=style&index=0&id=51ad7650&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ad7650"]])

export default __exports__